import { Link } from 'react-router';
import cnh from '~/helpers/cnh';
import buttonStyles from '~/styles/button.module.css';
import utilStyles from '~/styles/utils.module.css';
import Spinner from './Spinner';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'link' | 'button' | 'submit' | 'router-link';
  href?: string;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  styleType?: 'primary' | 'secondary' | 'link' | 'outlinePrimary' | 'outlineSecondary';
};

export default function Button({
  children,
  onClick,
  type = 'button',
  href,
  className,
  disabled = false,
  loading = false,
  loadingText,
  styleType = 'primary',
}: Props) {
  const styleTypeClasses = {
    primary: buttonStyles.btnPrimary,
    secondary: buttonStyles.btnSecondary,
    link: buttonStyles.btnLink,
    outlinePrimary: buttonStyles.btnOutlinePrimary,
    outlineSecondary: buttonStyles.btnOutlineSecondary,
  };
  const classes = cnh(buttonStyles.btn, styleTypeClasses[styleType], className ?? '');

  const onPreventClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
  };

  if (type === 'router-link') {
    return (
      <Link
        to={href ?? ''}
        className={cnh(classes, disabled ? buttonStyles.btnDisabled : '')}
      >
        {children}
      </Link>
    );
  }

  if (type === 'link') {
    return (
      <a
        href={href}
        className={cnh(classes, disabled ? buttonStyles.btnDisabled : '')}
        onClick={disabled ? onPreventClick : onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type === 'button' ? 'button' : 'submit'}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {
        loading && loadingText
          ? (
            <span className={utilStyles.flexItemsCenter}>
              <Spinner className={utilStyles.mrSmall} />
              {loadingText}
            </span>
          )
          : children
      }
    </button>
  );
}
